import React from 'react'
import Head from 'next/head'
import CrisprgrnaRoute from '../../../../../routes/SemiConfigurators/products/crisprgrna'
import PageError from '@src/components/PageError'
import getConfig from 'next/config'
import { useIntl } from 'react-intl'
import DefaultLayout from '@src/components/DefaultLayout'
import SemiConfiguratorRedesign from '@src/routes/SemiConfigurators/products/SemiConfiguratorRedesign'

const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()

const Crisprgrna = () => {
  const intl = useIntl()
  if (!featureFlags.semiConfigurators) {
    return (
      <DefaultLayout>
        <PageError />
      </DefaultLayout>
    )
  } else {
    return (
      <React.Fragment>
        <Head>
          <title>
            {intl.formatMessage({
              id: 'SEMICONF_TITLE_CRISPR_GRNA',
              defaultMessage: 'CRISPR gRNA',
            })}
          </title>
        </Head>
        {featureFlags.semiConfigRedesign ? (
          <SemiConfiguratorRedesign />
        ) : (
          <CrisprgrnaRoute />
        )}
      </React.Fragment>
    )
  }
}

export default Crisprgrna
